<template>
  <div id="app">
    <Header></Header>
    <div class="main-container">
      <Pre-page :nav="prePageNav"></Pre-page>
      <div class="articleList-container">
        <div class="articleList-content">
          <div class="articleList">
            <div class="product-basic">
              <div class="product-img" v-if="product.websiteImg || product.img">
                <el-image
                  :src="product.websiteImg || product.img"
                  fit="contain"
                >
                  <div slot="placeholder" class="image-slot">
                    <img
                      src="data:image/png;base64,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"
                    />
                  </div>
                </el-image>
              </div>

              <div class="product-info">
                <div class="title">{{ product.productName }}</div>
                <div class="product-line">
                  <span class="product-tag">【产地】</span>
                  <span class="product-text">{{ product.productionName }}</span>
                </div>
                <div class="product-line">
                  <span class="product-tag">【起发量】</span>
                  <span class="product-text">{{ product.remarks }}</span>
                </div>
                <div class="product-line">
                  <span class="product-tag">【运费】</span>
                  <span class="product-text">{{ product.postage }}</span>
                </div>
                <div class="product-line">
                  <span class="product-tag">【规格】</span>
                  <span class="product-text">{{
                    product.productRemarkEntities | remarkSplit
                  }}</span>
                </div>
                <a
                  class="product-btn"
                  :href="'/zwal.html'"
                >
                  <span>应用案例</span>
                  <img src="../assets/img/right_arr_white.png" alt />
                </a>
                <div class="product-qrcode">
                  <img src="../assets/img/product-qrcode.png" alt />
                  <span>
                    扫码添加客服微信
                    <br />咨询更多产品信息
                  </span>
                </div>
              </div>
            </div>

            <div class="product-cont">
              <div v-html="product.websiteDetails || product.details"></div>
            </div>
            <Adv></Adv>
            <div class="research-links">
              <div class="research-link">
                <span>上一个</span><a v-if="!prevPro||!prevPro.proName">无</a
                ><a :href="'nzscxq.html?id='+prevPro.proId+'&proSort='+prevPro.proSort+'&categoryId='+prevPro.categoryId" v-else
                  >{{prevPro.proName}}</a
                >
              </div>
              <div class="research-link">
                <span>下一个</span><a v-if="!nextPro||!nextPro.proName">无</a
                ><a :href="'nzscxq.html?id='+nextPro.proId+'&proSort='+nextPro.proSort+'&categoryId='+nextPro.categoryId" v-else>{{nextPro.proName}}</a>
              </div>
            </div>
            <hotProduct :list="productList"></hotProduct>
          </div>

          <!-- <div class="likeList">
            <Like :list="cardList"></Like>
          </div> -->
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "../components/header.vue";
import Footer from "../components/footer.vue";
// import Pagination from "../components/pagination.vue";
// import Like from "../components/likeList.vue";
import PrePage from "../components/PrePage.vue";
// import OneTitle from "../components/OneTitle.vue";
import Adv from "../components/adv.vue";
import hotProduct from "../components/hotProduct.vue";

export default {
  name: "app",
  components: {
    Header,
    Footer,
    // Pagination,
    // Like,
    PrePage,
    // OneTitle,
    Adv,
    hotProduct,
  },
  data: () => {
    return {
      totalpage: 10,
      currentpage: 1,
      loading: false,

      cardType: "0", //0 农技文章
      research: {
        createTime: "",
      },
      comments: [],
      prePageNav: [
        {
          name: "首页",
          to: "/",
        },
        {
          name: "农资商城",
          to: "nzsc.html",
        },
        {
          name: "热销爆款",
          to: "nzsc.html?type=1",
        },
        {
          name: "详情",
          to: "",
        },
      ],
      cardList: [
        {
          title: "",
          desc: "",
          author: "",
          time: "",
          clickViews: 10,
          imgUrl: "",
        },
      ],
      id: "",
      product: {},
      productInfo: {},
      productList: [],
      prevPro: {}, // 上一个商品
      nextPro: {}, // 下一个商品
    };
  },
  beforeMount() {
    function getUrlString() {
      var urlStr = window.location.search; //?sex=man&age=20
      console.log(urlStr);
      if (urlStr != null && urlStr.toString().length > 1) {
        var myUrlStr = urlStr.substr(1); //sex=man&age=20
        var array1 = myUrlStr.split("&"); //["sex=man"],["age=20"]
        var getString = {};
        for (var i = 0; i < array1.length; i++) {
          getString[array1[i].split("=")[0]] = array1[i].split("=")[1]; //["sex","man"]["age","20"]
        }
        return getString;
      } else {
        console.log("无参数");
      }
    }
    var gus = new getUrlString();
    console.log(gus);

    this.id = gus.id;

    this.$axios
      .get(
        `category/showProduct?productId=${gus.id}&proSort=${gus.proSort}&categoryId=${gus.categoryId}`
      )
      .then((res) => {
        console.log(res);
        this.productInfo = res.data.information.info;
        this.$set(this.prePageNav,2,{
          name: this.productInfo.categoryName,
          to: `nzsc.html?type=${this.productInfo.categoryId}`,
        })
        this.prevPro = res.data.information.up;
        this.nextPro = res.data.information.move;
        this.product = res.data.information.info.productEntity;
        document.getElementsByTagName('title')[0].innerHTML = this.product.productName;
      });

    this.$axios
      .get(`websiteHotSale/websiteHotSaleList`)
      .then((data) => {
        data = data.data;
        this.productList = data.information
      });
  },
  methods: {
    pageChange(n) {
      console.log(n);
      this.loading = true;
      this.$axios
        .post(
          `https://m.nongjike.cn/app/community/findComment?userId=1&id=${this.id}&pageNum=${n}&pageSize=10`
        )
        .then((res) => {
          this.comments = res.data.information.list;
          this.loading = false;
          //   this.totalpage = res.data.information.total
        });
    },
  },
  filters: {
    nameNoPhone(nickName) {
      if (!nickName) {
        return nickName;
      } else {
        nickName = nickName.replace(/\d{11}/gi, "***");
        return nickName;
      }
    },
    remarkSplit(arr) {
      if (!arr) {
        return "";
      }
      let names = arr.map((item) => item.remark);
      return names.join("、");
    },
    upTo5(num) {
      num = parseInt((num - 0) * 5);
      if (num - 10000 > 0) {
        num = parseInt(num / 10000) + "w+";
      }
      return num;
    },
    timeAgo(time) {
      let between = Date.now() / 1000 - new Date(time).getTime() / 1000;
      if (between < 0) {
        between += 25200;
      }
      if (between < 3600) {
        return `${~~(between / 60)} 分钟前`;
      } else if (between < 86400) {
        return `${~~(between / 3600)} 小时前`;
      } else {
        return `${time.split(" ")[0]}`;
      }
    },
  },
  mounted: () => {},
};
</script>

<style lang="scss">
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
  margin-top: 121px;
}
a {
  & > * {
    text-decoration: none;
  }
  text-decoration: none;
}
video {
  width: 100%;
}
.image-slot {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #f5f5f5;
  img {
    width: 50%;
    height: auto;
    display: block;
  }
}

.main-container {
  width: 100%;
  .header-bg {
    width: 100%;
    display: block;
  }
}
.research-links {
  margin: 40px 0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .research-link {
    width: 45%;
    text-align: left;
    vertical-align: bottom;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    span {
      font-size: 14px;
      color: #666;
      margin-right: 16px;
    }
    a {
      color: #333;
      font-size: 16px;
    }
  }
}
.articleList-container {
  width: 100%;
  background: #fff;
  .articleList-content {
    padding-bottom: 80px;
    width: 1200px;
    margin: 0 auto;
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: flex-start;
    padding-top: 30px;
    .articleList {
      width: 100px;
      flex-grow: 1;
    }

    .likeList {
      width: 360px;
    }
  }
}

.product-cont {
  width: 100%;
  overflow: hidden;
  margin: 22px 0;
  img {
    max-width: 100%;
    display: block;
    height: auto !important;
  }
  video {
    max-width: 100%;
    width: 100%;
  }
}
.crop-title {
  font-size: 24px;
  color: #1f1f1f;
  padding-top: 20px;
  text-align: center;
  margin-bottom: 12px;
}
.crop-times {
  padding-bottom: 40px;
}
.crop-infos {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 22px;
  .crop-info-item {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: nowrap;
    color: #999;
    font-size: 14px;
    margin-left: 8px;
    line-height: 20px;
    margin-right: 15px;
    .iconfont {
      font-size: 16px;
      margin-right: 4px;
    }
    img {
      width: 16px;
      height: 16px;
      margin-right: 4px;
    }
  }
}
.product-cont {
  width: 100%;
  overflow: hidden;
  margin: 40px 0;
  img {
    max-width: 100%;
    display: block;
    height: auto !important;
  }
}
.product-basic {
  width: 100%;
  overflow: hidden;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  .product-qrcode {
    margin-top: 30px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    span {
      font-size: 14px;
      color: #1e1e1e;
    }
    img {
      width: 128px;
      height: 128px;
      display: block;
      margin-right: 8px;
    }
  }
  .product-btn {
    width: 90px;
    height: 30px;
    font-size: 12px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 15px;
    background: #65b825;
    cursor: pointer;
    position: relative;
    left: 6px;
    color: #fff;
    span {
      vertical-align: middle;
    }
    img {
      width: 12px;
      height: 12px;
      vertical-align: middle;
      margin-left: 2px;
    }
  }
  .product-img {
    width: 394px;
    height: 394px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    border: 1px solid #e6e6e6;
    background: #fff;
    margin-right: 20px;
    .el-image {
      min-width: 394px;
      height: 394px;
      .image-slot > img {
        width: 394px;
        height: 394px;
        display: block;
      }
    }
  }
  .product-info {
    width: 100px;
    flex-grow: 1;
    padding-top: 16px;
    .title {
      font-size: 24px;
      padding-left: 22px;
      font-weight: bold;
      color: #000;
      position: relative;
      margin-bottom: 10px;
      &::before {
        content: "";
        display: block;
        width: 8px;
        height: 24px;
        background: #65b825;
        position: absolute;
        left: 6px;
        top: 50%;
        transform: translateY(-50%);
      }
    }
    .product-line {
      font-size: 16px;
      color: #666666;
      margin-bottom: 12px;
      .product-tag {
        color: #65b825;
        margin-right: 10px;
      }
    }
  }
}
@media screen and (max-width: 1200px) {
  #app {
    margin-top: 91px;
  }
  .login_container {
		padding-left: 10px;
	}
	.headers {
		width: 100%;
		padding-left: 10px;
	}
	#app {
		overflow: hidden;
	}
	#app .headers .header-nav {
		display: none;
	}

  .crop-selector-container .crop-selector{
    width: 100%;
  }
  .crop-selector-container .crop-selector .crop-item .crop-group{
    margin-right: 0;
    font-size: 14px;
  }
  .crop-selector-container .crop-selector .crop-item .crop-titles{
    font-size: 14px;
    line-height: 20px;
    a{
      min-width: 80px;
      margin-bottom: 6px;
    }
  }
  .crop-selector-container{
    padding: 20px 10px 14px;
  }
  .likeList{
    display: none;
  }
  .articleList-container .articleList-content{
    width: 100%;
    .articleList{
      margin-right: 0;
      padding: 0 10px;
    }
  }
  .product-basic{
    flex-direction: column;
    .product-img{
      width: 100%;
      height: auto;
      .el-image{
        width: 100%;
        min-width: 100%;
        height: auto;
      }
    }
    .product-info{
      width: 100%;
      .title{
        font-size: 16px;
      }
      .product-line{
        font-size: 14px;
        margin-bottom: 8px;
      }
    }
  }
  .product-basic .product-qrcode img{
    width: 100px;
    height: 100px;
    margin-right: 20px;
  }
}
</style>
